import React from 'react';
import './pagination.css';
const Pagination = ({ currentPage, totalPages, onPageChange, showRange = 2 }) => {
    const generatePageNumbers = () => {
        const pages = [];
        const start = Math.max(1, currentPage - showRange);
        const end = Math.min(totalPages, currentPage + showRange);

        if (start > 1) {
            pages.push(1); // First page
            if (start > 2) {
                pages.push('...'); // Ellipsis
            }
        }

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        if (end < totalPages) {
            if (end < totalPages - 1) {
                pages.push('...'); // Ellipsis
            }
            pages.push(totalPages); // Last page
        }

        return pages;
    };

    const pageNumbers = generatePageNumbers();

    return (
        <nav>
            <ul className="pagination">
                {/* Previous Button */}
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button
                        className="page-link"
                        onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        &laquo; Prev
                    </button>
                </li>

                {/* Page Numbers */}
                {pageNumbers.map((page, index) =>
                    typeof page === 'number' ? (
                        <li
                            key={index}
                            className={`page-item ${page === currentPage ? 'active' : ''}`}
                        >
                            <button
                                className="page-link"
                                onClick={() => onPageChange(page)}
                            >
                                {page}
                            </button>
                        </li>
                    ) : (
                        <li key={index} className="page-item disabled">
                            <span className="page-link">{page}</span>
                        </li>
                    )
                )}

                {/* Next Button */}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button
                        className="page-link"
                        onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next &raquo;
                    </button>
                </li>
            </ul>
        </nav>
    );
};

export default Pagination;
